module.exports = __webpack_public_path__ + "img/main-logo.f97b8d41.png";